let config;

if (process.env.NODE_ENV === "production") {
  config = {
    $api_url: "http://fiwitech.com/fapi",
    timeoutDuration: 30000,
    someOtherProps: 'xyz',
    api_username: 'ld.vue@fiwitech.com',
    api_password: 'PL*d15$sR',
    api_client_id: 1,
    api_client_secret: 'YfigZvV9DgpbHOSPYMHb4spQgZsGgZK2BqP9Mf1K',
    api_grant_type: 'password'
  };
}
else if (process.env.NODE_ENV === "staging") {
  config = {
    $api_url: "http://localhost/fapi",
    timeoutDuration: 30000,
    someOtherProps: 'xyz',
    api_username: 'luckyday.vue@fiwitech.com',
    api_password: 'password',
    api_client_id: 1,
    api_client_secret: 'MzuDwaob30alyC01tJJ7q4OuHzK6LgGDOrnpZvY0',
    api_grant_type: 'password'
  };
}
else {
  config = {
    $api_url: "http://localhost/fapi",
    timeoutDuration: 30000,
    someOtherProps: 'abc',
    api_username: 'luckyday.vue@fiwitech.com',
    api_password: 'password',
    api_client_id: 1,
    api_client_secret: 'MzuDwaob30alyC01tJJ7q4OuHzK6LgGDOrnpZvY0',
    api_grant_type: 'password'
  };
}

/*config.api_username = 'luckyday.vue@fiwitech.com'
config.api_password = 'password'
config.api_client_id = 1
config.api_client_secret = 'MzuDwaob30alyC01tJJ7q4OuHzK6LgGDOrnpZvY0'
config.api_grant_type = 'password'*/

config.campaign_id = 5604

export { config }



// WEBPACK FOOTER //
// ./src/config.js